module.exports = __webpack_public_path__ + "static/media/brsrBannerImage1.ef23dcaf.svg";